export const SPIL_ID_PENDING = 'SPIL_ID_PENDING';
export const SPIL_ID_SUCCESS = 'SPIL_ID_SUCCESS';
export const SPIL_ID_RESET = 'SPIL_ID_RESET';
